import ActionTypes from '../actions/actionTypes';
import InitialState from './initialState';

const selectedReleasesReducer = (state = InitialState.selectedReleases, action) => {
  switch (action.type) {
    case ActionTypes.SELECTED_RELEASES_REQUEST_SUCCEEDED: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};

export default selectedReleasesReducer;
